import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { UserInfo } from '@app/core/models';
import { AlertService } from '@app/core/services';
import { UserInfoService } from '@app/core/services/state/user-info';
import { AuthGuardPermission } from '../models/auth-guard-permission';
import { AuthService } from './auth.service';
import { AlertNewSnakbarService } from '@app/core/services/alert-new-snakbar.service';


@Injectable()
export class AuthGuard {

	roles: string[];

	constructor(
		private authService: AuthService,
		private router: Router,
		private userInfoService: UserInfoService,
		// private alertService: AlertService,
		private alertNewSnakbarService: AlertNewSnakbarService,
	) {
		this.getUserRoles();
	}

	async canLoad(
		route: Route,
		segments: UrlSegment[]
	): Promise<boolean> {
		const returnUrl = `/${segments.map(s => s.path).join('/')}`;
		return await this.hasAuthUserAccessToThisRoute(returnUrl);

		// use when we have permission for user
		// const permissionData = route.data['permission'];
		// if (Array.isArray(permissionData.permittedRoles)) {
		//      const isInRole = this.authService.isAuthUserInRole(
		//              permissionData.permittedRoles[0]
		//      );
		//      if (isInRole) {
		//              return true;
		//      } else {
		//              return false;
		//      }

		// }
	}

	async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

		const loggedIn = await this.authService.isLoggedInSafe();

		if (!loggedIn) {
			this.isLogOut(state);
			return false;
		}

		const permissionData: AuthGuardPermission = route.data['permission'];

		if (!permissionData) {
			return true;
		}

		if (Array.isArray(permissionData.permittedRoles)) {
			if (this.isInRole(permissionData.permittedRoles)) {
				return true;
			}
			this.showAccessDenied(state);
			return false;
		}

		if (Array.isArray(permissionData.deniedRoles)) {
			let hasAccess = false;
			const roles = this.roles.join(' ');

			for (const role in permissionData.deniedRoles) {
				hasAccess = roles.includes(role.toLowerCase());
				if (hasAccess) {
					break;
				}
			}

			if (!hasAccess) {
				return true;
			}

			this.showAccessDenied(state);
			return false;
		}
	}

	private showAccessDenied(state: RouterStateSnapshot) {
		this.router.navigate(['/dashboard']);
		this.alertNewSnakbarService.snackBarError('AUTH.ACCESS_DENIED');
	}

	private async hasAuthUserAccessToThisRoute(returnUrl: string): Promise<boolean> {
		const loggedIn = await this.authService.isLoggedInSafe();
		if (loggedIn) {
			return true;
		}
		this.router.navigate(['/auth'], { queryParams: { returnUrl: returnUrl } });
		return false;
	}

	private isLogOut(state: RouterStateSnapshot) {
		this.router.navigate(['/auth'], {
			queryParams: { returnUrl: state.url }
		});
	}

	private getUserRoles(): void {
		this.userInfoService.getUserInfo$().subscribe((res: UserInfo) => {
			this.roles = res?.roles?.map(item => item.toLowerCase());
		});
	}

	private isInRole(role: string[]): boolean {
		const permittedRoles = role.map(item => item.toLowerCase());

		const result = permittedRoles.every(item => this.roles.includes(item));
		return result;
	}
}